document.addEventListener( 'DOMContentLoaded', function() {
	const expandableCards = document.querySelectorAll( '.expandable-card' );

	if ( ! expandableCards.length ) {
		return;
	}

	// Set initial state for the active card
	const initiallyActiveCard = document.querySelector( '.expandable-card.is-active' );
	if ( initiallyActiveCard ) {
		const richText = initiallyActiveCard.querySelector( '.rich-text' );
		if ( richText ) {
			richText.style.maxHeight = richText.scrollHeight + 'px';
		}
	}

	expandableCards.forEach( ( card ) => {
		const button = card.querySelector( 'button' );
		const richText = card.querySelector( '.rich-text' );

		if ( ! button || ! richText ) {
			return;
		}

		button.addEventListener( 'click', () => {
			// If the clicked card is already active, do nothing.
			if ( card.classList.contains( 'is-active' ) ) {
				return;
			}

			// Close all other cards
			expandableCards.forEach( ( otherCard ) => {
				if ( otherCard !== card ) {
					otherCard.classList.remove( 'is-active' );
					otherCard.querySelector( 'button' ).setAttribute( 'aria-expanded', 'false' );
					otherCard.querySelector( '.rich-text' ).style.maxHeight = null;
				}
			} );

			// Open the clicked card
			card.classList.add( 'is-active' );
			button.setAttribute( 'aria-expanded', 'true' );
			richText.style.maxHeight = richText.scrollHeight + 'px';
		} );
	} );
} );
